export function getGradeLabel(grade) {
    switch (grade) {
        case "S":
            return "Exceptional";
        case "A":
            return "Excellent";
        case "B":
            return "Good";
        case "C":
            return "Acceptable";
        case "D":
            return "Needs Improvement";
        case "F":
            return "Losing Money";
        default:
            return "Unknown";
    }
}

export function getGradeChipSx(grade) {
    if (grade === "S") {
        return {
            color: "#3b2f00",
            background: "#f2c94c",
            border: "1px solid #d4a017",
            boxShadow: "none",
        };
    }

    const styles = {
        A: {
            color: "#1b5e20",
            background: "#c8e6c9",
            border: "1px solid #81c784",
        },
        B: {
            color: "#0d47a1",
            background: "#bbdefb",
            border: "1px solid #64b5f6",
        },
        C: {
            color: "#e65100",
            background: "#ffe0b2",
            border: "1px solid #ffb74d",
        },
        D: {
            color: "#bf360c",
            background: "#ffccbc",
            border: "1px solid #ff8a65",
        },
        F: {
            color: "#b71c1c",
            background: "#ffcdd2",
            border: "1px solid #ef9a9a",
        },
    };

    return styles[grade] || {};
}
